<app-card-base [title]="title" [hasSubmit]="false" [hasFooter]="true">
  <ng-container header-right *ngTemplateOutlet="headerRight"></ng-container>
  <ng-container main *ngTemplateOutlet="contentMain"></ng-container>
</app-card-base>

<ng-template #contentMain>
  <div class="content">
    <div class="details">
      @for (doc of requiredDocs; track $index) {

      <div class="detail-doc" [class.is-sent]="doc.isSent">
        <span class="detail-doc-type">{{doc.type | buildingDocTypeTranslate}}</span>
        <span class="detail-doc-stage">({{doc.stage | bookletBuildingStageTranslate}})</span>
        <mat-icon class="detail-doc-icon" [matTooltip]="doc.isSent ? 'Document enregistré' : 'Document absent'">
          {{doc.isSent ? 'task_alt' : 'radio_button_unchecked'}}
        </mat-icon>
      </div>
      }
      @if(requiredDocs?.length === 0) {
      <div class="summary">{{summary}}</div>
      }
    </div>
  </div>
</ng-template>

<ng-template #headerRight>
  <button mat-flat-button color="primary" class="card-header-actions" (click)="edit()">
    <mat-icon>edit</mat-icon>
  </button>
</ng-template>
